import * as bc from "bc-js";

import { useEffect } from "react";
import { useParams } from "react-router";
import { LangueUtils } from "@oel/js-i18n";
import { en } from "./i18n/InfoPlansAccordD.i18n.en";
import { fr } from "./i18n/InfoPlansAccordD.i18n.fr";
import { GabaritNavigationUtil } from "../../../utils/gabarit-navigation/GabaritNavigationUtil";
import { IdPageEnum } from "../../../utils/gabarit-navigation/IdPageEnum";

export function InfoPlansAccordD() {
    const params = useParams();
    const libelles = new LangueUtils(fr, en).obtenirLibelles();

    useEffect(() => {
        document.title = libelles.titreOnglet;
        GabaritNavigationUtil.afficherGabarit(IdPageEnum.PAIEMENT_PAR_VERSEMENT_ADA);

        bc.changerContexte("ACCOUNT_Detail");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <oel-wc-ppve-info-plans-accord id-contexte={params.idContexte} />
        </div>
    );
}
